document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="number"]');
    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const change = button.dataset.quantityChange === 'plus' ? 1 : -1;
        const minimum = Number(input.min || 0);
        input.value = Math.max(minimum, Number(input.value || 0) + change);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const idInput = root.querySelector('input[name="id"]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const button = root.querySelector('[data-add-button]');
    const variantsScript = root.querySelector('[data-variants-json]');

    if (!select || !variantsScript) return;
    const variants = JSON.parse(variantsScript.textContent);

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      }
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldText;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    });
  });
});

function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
}
